type AppConfigKey = 'ENV' | 'IDP_URL' | 'ENABLE_DEV_CONFIGURATOR' | 'MIXPANEL_TOKEN'

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<Record<AppConfigKey, string>>
  }
}

const pick = (key: AppConfigKey, fallback: string | undefined): string => {
  const value = typeof window !== 'undefined' ? window.__APP_CONFIG__?.[key] : undefined
  if (value && value.length > 0) return value
  return fallback ?? ''
}

export const config = {
  env: pick('ENV', import.meta.env.VITE_ENV as string | undefined),
  idpUrl: pick('IDP_URL', import.meta.env.VITE_IDP_URL as string | undefined),
  enableDevConfigurator: pick(
    'ENABLE_DEV_CONFIGURATOR',
    import.meta.env.VITE_ENABLE_DEV_CONFIGURATOR as string | undefined,
  ),
  mixpanelToken: pick('MIXPANEL_TOKEN', import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined),
}
